export default __webpack_public_path__ + "static/media/VerticalTank_ti40781.fb442b51.png";